import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { InspectorService } from '../../service';

export type HighSeverityFindingsConfig = typeof HighSeverityFindingsConfig._.Config;

export const HighSeverityFindingsConfig = IntegrationConfig.make({
  service: InspectorService,
  name: Integration_Handler_Names_Enum.HighSeverityFindings,
  configSchema: z.object({}),
});
